import React, { useState, useRef, useEffect, useMemo } from "react"
import { Breadcrumb, Button, Slider, Breadcrumb_v2 } from "@components/anti"
import Image from "next/image"
import { Image as ImageAnti } from "components/anti"
import imgSample from "@public/img/sample/product.jpg"
import CardProduct from "components/global/card-product/card-product"
import {
  F_M_ADD_TO_BAG,
  F_M_ADD_WISHLIST,
  F_M_ADD_NOTIFY,
  sendDatalayerProduct,
} from "lib/function"
import HeartPNG from "assets/img/icon/ico_heart.svg"
import HeartFillPNG from "assets/img/icon/ico_heart-fill.svg"

//Utils
import Cookies from "js-cookie"
import {
  useClickOutside,
  useIsomorphicLayoutEffect,
  useScrollAnim,
  useWindowSize,
} from "components/hooks/hooks"
import { useDispatch, useSelector } from "react-redux"
import {
  SET_CARTS,
  SET_ADD_CART,
  SET_PRODUCT_ADDED,
  SET_SHOW_LOGIN,
  SET_WISHLIST,
  SET_SHOW_TOAST,
  SET_TEXT_TOAST,
  SET_TYPE_TOAST,
} from "lib/redux/types"
import { currencyFormatter } from "lib/utils/utils"
import { useRouter } from "next/router"

//Components
import ModalGuestNotify from "@components/modal-component/modal-guest-notify"
import CustomQty from "@components/global/custom-qty/custom-qty"

const ProductDetailsComp = ({
  data,
  locale,
  deliveryInfo,
  wishlists,
  token: serverToken,
  stock,
}) => {
  //Utils ******************************************************************************************************* //
  const [trigger, anim] = useScrollAnim()
  const dispatch = useDispatch()
  const Router = useRouter()
  const { width } = useWindowSize()
  const isMobile = width < 766
  let token = Cookies.get(`${process.env.ACCESS_TOKEN}`)
  let tokenGuest = Cookies.get(`${process.env.GUEST_TOKEN}`)
  const { wishlist, user_data, wishlist_data } = useSelector(
    (state) => state.auth
  )
  const productDetail = data?.product
  const dataLayerData = useMemo(
    () => ({
      ...productDetail,
      listName: Router.query?.listName || "Product Details",
      index: Router?.query?.index || 1,
    }),
    [productDetail, Router.query]
  )
  //Utils ******************************************************************************************************* //
  const handleToast = (type, message, timeout = 3000) => {
    dispatch({ type: SET_SHOW_TOAST, payload: true })
    dispatch({ type: SET_TYPE_TOAST, payload: type })
    dispatch({ type: SET_TEXT_TOAST, payload: message })
    setTimeout(() => {
      dispatch({ type: SET_SHOW_TOAST, payload: false })
      dispatch({ type: SET_TYPE_TOAST, payload: null })
    }, timeout)
  }
  //States ****************************************************************************************************** //
  const modalGuest = "modal-email-guest"
  const previewRef = useRef()
  // const previewRefMobile = useRef()
  // const qtyRef = useRef()
  const [currentSlider, setCurrentSlider] = useState(0)
  const [breadData, setBreadData] = useState(null)
  // const [activeQty, setActiveQty] = useState(false)
  const [state, setState] = useState({
    imagePreview: data?.product?.images[0],
    qty: 1,
    stock: stock?.stock,
    recentView: null,
    addCartLoading: false,
    product: data.product,
    showGuestNotify: null,
    is_wishlist: wishlist_data?.find((item) => item.id === data?.product?.id)
      ? true
      : false,
  })
  //States ****************************************************************************************************** //
  useEffect(() => {
    let dataRecent = window.localStorage.getItem("recent-view")
    let recentProduct = null
    if (dataRecent) {
      recentProduct = JSON.parse(dataRecent).reverse()
    }
    setState({
      imagePreview: data?.product?.images[0],
      qty: data?.product?.skus[0]?.stock > 0 ? 1 : 0,
      stock: stock?.stock,
      recentView: recentProduct,
      addCartLoading: false,
      product: data.product,
      is_wishlist: wishlist_data?.find((item) => item.id === data?.product?.id)
        ? true
        : false,
    })
  }, [data, wishlist_data])

  //Functions *************************************************************************************************** //
  const handleClickThumbnail = (index) => {
    setCurrentSlider(index)
    // previewRef.current.slickGoTo(index)
    // previewRefMobile.current.slickGoTo(index)
  }
  const handleClickQty = (type) => {
    if (type == "dec") {
      if (state.qty > 1)
        return setState((prev) => ({ ...prev, qty: state.qty - 1 }))
    } else if (type == "inc") {
      if (state.qty < state.stock) {
        return setState((prev) => ({ ...prev, qty: state.qty + 1 }))
      }
    } else if (typeof type === "number") {
      return setState((prev) => ({ ...prev, qty: type }))
    }
  }

  // useClickOutside(qtyRef, () => {
  //   if (activeQty) {
  //     setActiveQty(false)
  //   }
  // })

  const handleRecentlyView = () => {
    let id = data?.product?.id
    let currentView = window.localStorage.getItem("recent-view")
    if (currentView) currentView = JSON.parse(currentView)
    if (currentView && currentView.length > 0) {
      let find = currentView.find((e) => e.id === id)
      if (find) {
        let index = currentView.findIndex((e) => e.id === id)
        let dataJSON = [...currentView]
        dataJSON[index] = { ...data?.product }
        window.localStorage.setItem("recent-view", JSON.stringify(dataJSON))
      } else {
        let dataJSON = JSON.stringify([...currentView, { ...data?.product }])
        window.localStorage.setItem("recent-view", dataJSON)
      }
      setState((prev) => ({
        ...prev,
        recentView: currentView.filter((el) => el.id !== id),
      }))
    } else {
      window.localStorage.setItem(
        "recent-view",
        JSON.stringify([{ ...data?.product }])
      )
    }
  }

  const handleAddCart = async () => {
    let skuId = state?.product?.skus[0]?.id

    setState((prev) => ({ ...prev, addCartLoading: true }))
    let sendData = {
      sku_id: skuId,
      quantity: state.qty,
      lang: locale,
    }
    let { data, errors } = await F_M_ADD_TO_BAG(
      { ...sendData },
      token ?? tokenGuest
    )

    if (data?.addToCart?.message === "The stock is not sufficient") {
      const text =
        Router.locale === "id"
          ? "Mohon maaf produk yang anda pilih sudah melebihi stock yang tersedia. Silahkan cek kembali barang yang ingin ditambahkan ketika jumlah stock sudah tersedia"
          : "Oops! It looks like you've requested more items than we have in stock. Please adjust the quantity or check back later when we have more available"
      handleToast("error", text)
      setState((prev) => ({ ...prev, addCartLoading: false }))
      return
    }

    if (data?.addToCart?.status === "success") {
      let { items } = data.addToCart
      let myProduct = items.find(
        (el) => el.product_id == Number(state.product.id)
      )
      dispatch({ type: SET_CARTS, payload: data.addToCart })
      dispatch({ type: SET_ADD_CART, payload: true })
      dispatch({
        type: SET_PRODUCT_ADDED,
        payload: {
          image: myProduct.image,
          price: myProduct.price,
          product_id: myProduct.product_id,
          quantity: myProduct.quantity,
          sku_id: myProduct.sku_id,
          sell_price: myProduct.sell_price,
          title: myProduct.title,
        },
      })
      sendDatalayerProduct({
        event: "add_to_cart",
        type: 2,
        data: { ...dataLayerData, quantity: state.qty },
      })
      setState((prev) => ({ ...prev, addCartLoading: false }))
    } else {
      //!NEED ERROR HANDLING
      setState((prev) => ({ ...prev, addCartLoading: false }))
    }
  }

  const handleWishlist = async () => {
    if (token) {
      let { data, errors } = await F_M_ADD_WISHLIST({
        product_id: state.product.id,
      })
      if (data) {
        if (state.is_wishlist) {
          setState((prev) => ({ ...prev, is_wishlist: false }))
          dispatch({ type: SET_WISHLIST, payload: wishlist - 1 })
        } else {
          setState((prev) => ({ ...prev, is_wishlist: true }))
          dispatch({ type: SET_WISHLIST, payload: wishlist + 1 })
          sendDatalayerProduct({
            event: "add_to_wishlist",
            type: 1,
            data: { ...dataLayerData, quantity: state.qty },
          })
        }
        if (state.is_wishlist == 0)
          return dispatch({ type: SET_WISHLIST, payload: wishlist + 1 })
      } else {
        //!NEED ERROR HANDLING
      }
    } else {
      dispatch({ type: SET_SHOW_LOGIN, payload: "modal-login-id" })
    }
  }

  const handleReminder = async () => {
    if (user_data) {
      let { email } = user_data
      let sku_id = data?.product?.skus[0].id
      setState((prev) => ({ ...prev, addCartLoading: true }))
      let result = await F_M_ADD_NOTIFY({ email, sku_id }, serverToken)
      if (result?.data) {
        dispatch({ type: SET_SHOW_TOAST, payload: true })
        dispatch({ type: SET_TYPE_TOAST, payload: "success" })
        dispatch({
          type: SET_TEXT_TOAST,
          payload: result?.data?.addToNotify?.message,
        })
        window.scrollTo(0, 0)
        setState((prev) => ({ ...prev, addCartLoading: false }))
        setTimeout(() => {
          dispatch({ type: SET_SHOW_TOAST, payload: false })
        }, 3000)
      } else {
        //!NEED ERROR HANDLING
        setState((prev) => ({ ...prev, addCartLoading: false }))
      }
    } else {
      setState((prev) => ({ ...prev, showGuestNotify: modalGuest }))
    }
  }

  //Functions *************************************************************************************************** //

  //React Operations ******************************************************************************************** //
  // React.useEffect(() => console.log(data), [data])
  useIsomorphicLayoutEffect(handleRecentlyView, [data])
  useIsomorphicLayoutEffect(() => {
    // console.log(data)
    let initialBread = [
      { text: `${locale === "en" ? "Home" : "Beranda"}`, url: "/" },
    ]
    let { firstcategory, secondcategory, thirdcategory } = data?.product
    if (thirdcategory) {
      let { id, slug, title } = thirdcategory
      initialBread = [
        ...initialBread,
        { text: title, url: `/category/${id}` },
        { text: data?.product?.title },
      ]
    } else if (secondcategory) {
      let { id, slug, title } = secondcategory
      initialBread = [
        ...initialBread,
        { text: title, url: `/category/${id}` },
        { text: data?.product?.title },
      ]
    } else if (firstcategory) {
      let { id, slug, title } = firstcategory
      initialBread = [
        ...initialBread,
        { text: title, url: `/category/${id}` },
        { text: data?.product?.title },
      ]
    }
    if (initialBread.length > 1) {
      setBreadData(initialBread)
    }
  }, [data])
  //React Operations ******************************************************************************************** //
  return (
    <div className="sc-product-details">
      <ModalGuestNotify
        show={state.showGuestNotify}
        hide={() => setState((prev) => ({ ...prev, showGuestNotify: null }))}
        id={modalGuest}
        token={serverToken}
        sku_id={data?.product?.skus[0]?.id}
      />
      <div className="container">
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => Router.back()}
          />
        </div>
        {breadData ? (
          <Breadcrumb path={breadData} className="d-none d-sm-flex" />
        ) : null}

        <div className="row row-content">
          <div className="product-preview col-md-5 overflow-hidden">
            {/* <Slider
              forwardRef={(slider) => (previewRef.current = slider)}
              visibleInitial={1}
              showInitial={1}
              showXxlDown={1}
              showXlDown={1}
              showLgDown={1}
              showMdDown={1}
              showSmDown={1}
              dotsInitial={false}
              arrowsInitial={true}
              nextArrow={<CustomNextArrow />}
              prevArrow={<CustomPrevArrow />}
              className="product-review-slider"
              beforeChange={(current, next) => {
                setCurrentSlider(next)
              }}
            >
              {data?.product?.images.map((item, i) => (
                <div key={i}>
                  <Image
                    src={item}
                    alt="sample"
                    objectFit="cover"
                    layout="responsive"
                    width="6"
                    height="8"
                    quality={100}
                    // placeholder="blur"
                  />
                </div>
              ))}
            </Slider> */}
            <div className="product-review-slider">
              <Image
                src={data?.product?.images?.[currentSlider]}
                alt="sample"
                objectFit="cover"
                layout="responsive"
                width="6"
                height="8"
                quality={100}
                // placeholder="blur"
              />
            </div>
            <div className="product-thumbnails">
              <div className="counting-thumbnails">
                <h6>
                  {currentSlider + 1}/{data?.product?.images.length}
                </h6>
              </div>
              {data?.product?.images.map((item, i) => (
                <div
                  key={i}
                  className={`product-thumbnails__item ${
                    currentSlider == i ? `active` : ``
                  }`}
                  onClick={() => {
                    setState((prev) => ({ ...prev, imagePreview: item }))
                    handleClickThumbnail(i)
                  }}
                >
                  {/* <Image
                    src={item}
                    alt="sample"
                    objectFit="cover"
                    layout="responsive"
                    width="6"
                    height="8"
                    // placeholder="blur"
                  /> */}
                  <ImageAnti
                    src={item}
                    alt="sampe"
                    ratio="r-3-4"
                    className="product-thumbnails__img"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="wrapper-desc-product offset-md-1 col-md-5">
            <p className="product-category">
              {state.product?.firstcategory?.title}
            </p>
            <h2 className="product-title">
              {/* Sagres Dining Chair Natural (Leg Natural SR, Loom Seating) */}
              {state.product.title}
            </h2>
            <h4
              className={`price ${
                state.product.sell_price < state.product.price
                  ? "text-danger"
                  : ""
              }`}
            >
              {currencyFormatter("ID", state.product.sell_price ?? 0)}
              {state.product.price &&
                state.product.sell_price < state.product.price && (
                  <span className="discount ml-1 text-body">
                    {currencyFormatter("ID", state.product.price ?? 0)}
                  </span>
                )}
            </h4>

            {state.stock > 0 ? (
              <div className="product-qty">
                <h5 className="label-qty">Qty:</h5>
                <CustomQty
                  handleClickQty={handleClickQty}
                  qty={state.qty}
                  stock={state.stock}
                />
                <h5 className="stock-qty">
                  {locale === "id" ? "Stock saat ini" : "Current Stock"}:{" "}
                  {state.stock}
                </h5>
              </div>
            ) : (
              <p className="empty-stock">
                {locale === "id" ? "Stock Tidak Tersedia" : "Out of Stock"}{" "}
              </p>
            )}

            <div className="wrapper-btn">
              {state.stock > 0 ? (
                <Button
                  variant="primary"
                  loader
                  className={`btn-fluid ${state.addCartLoading && "loading"}`}
                  onClick={() => handleAddCart()}
                >
                  {locale === "id" ? "Tambah Keranjang" : "Add to Cart"}
                </Button>
              ) : (
                <Button
                  variant="primary"
                  loader
                  className={`btn-fluid ${state.addCartLoading && "loading"}`}
                  onClick={() => handleReminder()}
                >
                  {locale === "id" ? "Ingatkan Saya" : "Remind Me"}
                </Button>
              )}
              <Button
                variant="outline-secondary"
                className="btn-fluid"
                onClick={() => handleWishlist()}
              >
                <Image
                  src={state.is_wishlist ? HeartFillPNG : HeartPNG}
                  alt={"Icon"}
                  className="icon-heart"
                />
                <span className="ml-2">
                  {state.is_wishlist
                    ? locale === "id"
                      ? "Hapus dari Wishlist"
                      : "Remove from My Wishlist"
                    : locale === "id"
                    ? "Tambah ke Wishlist"
                    : "Add to My Wishlist"}
                </span>
              </Button>
            </div>

            <hr className="divider" />

            {/* PRODUCT INFORMATION *********************************************************** */}
            <div className="information-content">
              <h4 className="title-information">
                {locale === "id" ? "Informasi Produk" : "Product Information"}
              </h4>
              <div
                className="dangerous-content"
                dangerouslySetInnerHTML={{ __html: data?.product?.description }}
              />
            </div>
            {/* PRODUCT INFORMATION *********************************************************** */}

            <hr className="divider" />

            {/* DELIVERY INFORMATION *********************************************************** */}
            <div className="information-content">
              <h4 className="title-information">
                {locale === "id"
                  ? "Informasi Pengiriman"
                  : "Delivery Information"}
              </h4>
              <div
                className="dangerous-content"
                dangerouslySetInnerHTML={{ __html: deliveryInfo.content }}
              ></div>
            </div>
            {/* DELIVERY INFORMATION *********************************************************** */}
          </div>
        </div>

        {state.recentView && state.recentView.length > 0 ? (
          <div className="recently-wrapper">
            <h3 className="title-recently">
              {locale === "id" ? "Baru Dilihat" : "Recently Viewed"}
            </h3>

            {/* <div className={`recently-list mb-5 mt-4 d-sm-none`}>
              {state.recentView.slice(0, 12).map((item, i) => (
                <div key={i} className={`recently-item`}>
                  <CardProduct
                    img={imgSample}
                    {...item}
                    imgAlt={`sale-product-${i}`}
                  />
                </div>
              ))}
            </div> */}
            <div className="mb-5 mt-4 recent-content" ref={trigger}>
              <Slider
                showInitial={5.2}
                showXxlDown={5.2}
                showXlDown={4.2}
                showLgDown={3.2}
                showMdDown={2.2}
                showSmDown={2.2}
                dotsInitial={false}
                arrowsInitial={true}
                nextArrow={<CustomNextArrow />}
                prevArrow={<CustomPrevArrow />}
              >
                {state.recentView.slice(0, 12).map((item, i) => (
                  <CardProduct
                    key={i}
                    // img={imgSample}
                    {...item}
                    imgAlt={`sale-product-${i}`}
                    className={`${anim(i + 1)}`}
                    noHeartIcon
                    listName={"Recently Viewed"}
                    index={i + 1}
                  />
                ))}
              </Slider>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}

const CustomPrevArrow = (props) => {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <div className="wrapper-arrow">
        <span className="air ai-chevron-left" />
      </div>
    </div>
  )
}

const CustomNextArrow = (props) => {
  const { className, onClick } = props
  return (
    <div className={className} onClick={onClick}>
      <div className="wrapper-arrow">
        <span className="air ai-chevron-right" />
      </div>
    </div>
  )
}

export default ProductDetailsComp
